import React from 'react';
import AllPlayersTable from '../TournamentLiveEvents/components/AllPlayersTable';

const TournamentLeaderboard = ({ players, myPlayers, userId, tournament, totals }) => {
  const resolvedPlayers = Array.isArray(players) ? players : [];

  const myPlayersFiltered =
    userId && resolvedPlayers.length > 0
      ? resolvedPlayers.filter((player) => player.userId === userId)
      : myPlayers || [];

  const allPlayersFiltered =
    userId && resolvedPlayers.length > 0
      ? resolvedPlayers.filter((player) => player.userId !== userId)
      : resolvedPlayers;

  const skinsFromPlayers = resolvedPlayers.reduce((sum, player) => {
    if (Array.isArray(player?.skinInfo) && player.skinInfo.length > 0) {
      return sum + player.skinInfo.filter(Boolean).length;
    }
    return sum + Number(player?.totalSkins ?? player?.skins ?? 0);
  }, 0);

  const sawOffPointsFromPlayers = resolvedPlayers.reduce((sum, player) => {
    if (Array.isArray(player?.sawOffInfo) && player.sawOffInfo.length > 0) {
      return sum + player.sawOffInfo.filter(Boolean).length;
    }
    return sum + Number(player?.totalSawOffs ?? player?.sawoffs ?? 0);
  }, 0);

  const totalSkins = totals?.totalSkins ?? skinsFromPlayers;
  const totalSawoffs =
    totals?.totalSawoffs ?? (sawOffPointsFromPlayers > 0 ? Math.max(1, Math.round(sawOffPointsFromPlayers / 2)) : 0);

  return (
    <div className="tournament-leaderboard">
      {/* My Players Section */}
      {myPlayersFiltered.length > 0 && (
        <AllPlayersTable
          players={myPlayersFiltered}
          totalSkins={totalSkins}
          totalSawoffs={totalSawoffs}
          title="My Players"
          showTotals={false}
          tournament={tournament}
        />
      )}

      {/* All Players Section */}
      <AllPlayersTable
        players={userId ? allPlayersFiltered : resolvedPlayers}
        totalSkins={totalSkins}
        totalSawoffs={totalSawoffs}
        title={userId && myPlayersFiltered.length > 0 ? 'All Players' : undefined}
        showTotals={false}
        tournament={tournament}
      />
    </div>
  );
};

export default TournamentLeaderboard;